// Every field on these pages posts while you type, so without this one number costs one request per
// keystroke. Keyed rather than per-call so a timer belongs to a field-and-participant, not to a closure.
const debounceTimers: Record<string, number> = {};

function Debounce(key: string, delayMs: number, action: () => void): void {
    clearTimeout(debounceTimers[key]);
    debounceTimers[key] = setTimeout(action, delayMs);
}

function CancelDebounce(key: string): void {
    clearTimeout(debounceTimers[key]);
    delete debounceTimers[key];
}
